import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiDeleteMyWishlistRequestedPayload {
  readonly actionId: number;
  readonly parentActionId: number;
  readonly id: string;
}

export const apiDeleteMyWishlistRequestedType = 'api/wishlist/deleteMyWishlist--requested';
export const apiDeleteMyWishlistRequested = createAction<ApiDeleteMyWishlistRequestedPayload>(
  apiDeleteMyWishlistRequestedType
);
export type ApiDeleteMyWishlistRequestedAction = ReturnType<typeof apiDeleteMyWishlistRequested>;

export interface ApiDeleteMyWishlistSucceededPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
}

export const apiDeleteMyWishlistSucceededType = 'api/wishlist/deleteMyWishlist--succeeded';
export const apiDeleteMyWishlistSucceeded = createAction<
  ApiDeleteMyWishlistSucceededPayload,
  typeof apiDeleteMyWishlistSucceededType
>(apiDeleteMyWishlistSucceededType);
export type ApiDeleteMyWishlistSucceededAction = ReturnType<typeof apiDeleteMyWishlistSucceeded>;

export interface ApiDeleteMyWishlistFailedPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly error: WishlistError;
}

export const apiDeleteMyWishlistFailedType = 'api/wishlist/deleteMyWishlist--failed';
export const apiDeleteMyWishlistFailed = createAction<
  ApiDeleteMyWishlistFailedPayload,
  typeof apiDeleteMyWishlistFailedType
>(apiDeleteMyWishlistFailedType);
export type ApiDeleteMyWishlistFailedAction = ReturnType<typeof apiDeleteMyWishlistFailed>;
